<p>loading works!</p>
<p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="4" fill="var(--surface-ground)" animationDuration=".5s" >
</p-progressSpinner>
